import React, { FC } from 'react';
import { ReportsCardHeaderProps } from './types';

const ReportsCardHeader: FC<ReportsCardHeaderProps> = ({ title = '' }) => (
  <div style={{ fontWeight: 700, width: '50%', display: 'inline-block' }}>{title}</div>
);

export default ReportsCardHeader;
